import { Card, CardHeader, Typography } from "@mui/material";
import { FaAngleDoubleDown } from "react-icons/fa";

const LazyPosHeader = () => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            النقاط الغير نشطة
          </Typography>
        }
        avatar={<FaAngleDoubleDown size={20} />}
      />
    </Card>
  );
};

export default LazyPosHeader;
